import * as React from 'react';



export class RenderizarReporte extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ReporteHtml: ""
        }
    }

     componentDidMount() {
        this.setState( {
            ReporteHtml: this.props.ReporteHtml
        });
    }
    
    render() {
        return (
            <div dangerouslySetInnerHTML={{ __html: this.state.ReporteHtml }} />
        );
    }
}

export default RenderizarReporte;